import PremiumListing from './PremiumListing';

export default PremiumListing;
